<div class="wrapper w-100">
  <!-- Sidebar -->

  <nav id="sidebar" [ngClass]="status ? 'active' : ''">
    <div class="close-button" type="button" id="sidebarCollapse" (click)="status=!status">
      @if (status) {
        <span><i class="fas fa-angle-right"></i></span>
      }

      @if (!status) {
        <span><i class="fas fa-angle-left"></i></span>
      }
    </div>
    <div class="sidebar-header">
      <h3>{{'NavMenu.RealEstateToolkit'|translate}}</h3>
    </div>

    <ul class="list-unstyled components">

      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'Newsroom.SearchTitle'|translate}}" routerLink="newsroom">{{'Newsroom.SearchTitle'|translate}}</a>
      </li>

      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'Prop13.SearchTitle'|translate}}" routerLink="proposition-13">{{'Prop13.SearchTitle'|translate}}</a>
      </li>
      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'Prop19.SearchTitle'|translate}}" routerLink="proposition-19">{{'Prop19.SearchTitle'|translate}}</a>
      </li>
      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'NavMenu.PropSearchTool'|translate}}" routerLink="property-search">{{'NavMenu.PropSearchTool'|translate}}</a>
      </li>
      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'DataSales.SearchTitle'|translate}}"   routerLink="data-sales">{{'DataSales.SearchTitle'|translate}}</a>
      </li>
      <li>
        <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'NavMenu.DisasterRelief'|translate}}" routerLink="disaster-relief">{{'NavMenu.DisasterRelief'|translate}}</a>
      </li>
      <!-- <li>
      <a routerLinkActive="active-tab" (click)="status=!status" routerLink="supplemental-tax-estimator">{{'NavMenu.SupplementalEstimator'|translate}}</a>
    </li> -->
    <li>
      <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'NavMenu.ChangeMailingAdd'|translate}}" routerLink="change-of-mailing-address">{{'NavMenu.ChangeMailingAdd'|translate}}</a>
    </li>
    <li>
      <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'NavMenu.NewConst'|translate}}" routerLink="new-construction">{{'NavMenu.NewConst'|translate}}</a>
    </li>
    <li>
      <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'RealEstateFraud.SearchTitle'|translate}}" routerLink="real-estate-fraud">{{'RealEstateFraud.SearchTitle'|translate}}</a>
    </li>
    <!--
    <li>
      <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'FactorsPropValue.SearchTitle'|translate}}" routerLink="factors-prop-value">{{'FactorsPropValue.SearchTitle'|translate}}</a>
    </li>
    -->
    <li>
      <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'CalculateFMV.SearchTitle'|translate}}" routerLink="how-we-calculate-fmv">{{'CalculateFMV.SearchTitle'|translate}}</a>
    </li>
    <li>
      <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'WillsandTrust.SearchTitle'|translate}}" routerLink="wills-and-trusts">{{'WillsandTrust.SearchTitle'|translate}}</a>
    </li>
    <li>
      <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'NavMenu.NewHomeowners'|translate}}" routerLink="new-homeowners">{{'NavMenu.NewHomeowners'|translate}}</a>
    </li>
    <li>
      <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'NavMenu.HomeExv2'|translate}}" routerLink="apply-for-hox">{{'NavMenu.HomeExv2'|translate}}</a>
    </li>

    <li>
      <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'Refinance.SearchTitle'|translate}}" routerLink="refinance">{{'Refinance.SearchTitle'|translate}}</a>
    </li>

    <li>
      <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'WhenReassessed.SearchTitle'|translate}}" routerLink="when-do-i-get-reassessed">{{'WhenReassessed.SearchTitle'|translate}}</a>
    </li>
    <li>
      <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'NavMenu.DeathofOwner'|translate}}" routerLink="death-of-a-property-owner">{{'NavMenu.DeathofOwner'|translate}}</a>
    </li>
    <li>
      <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'NavMenu.Events'|translate}}" routerLink="events">{{'NavMenu.Events'|translate}}</a>
    </li>
    <li>
      <a [innerHTML]="'Newsletters'|translate" routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'Newsletters'|translate}}" routerLink="newsletters"></a>
    </li>
    <li>
      <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'Homeowner Alert Service'|translate}}" routerLink="enotification">{{'Homeowner Alert Service'|translate}}</a>
    </li>
    <li>
      <a routerLinkActive="active-tab" (click)="status=!status" aria-label="{{'NavMenu.AnnualReport'|translate}}" routerLink="annualreport">{{'NavMenu.AnnualReport'|translate}}</a>
    </li>



  </ul>

</nav>
<div id="content">

  <!-- <button type="button" id="sidebarCollapse" (click)="status=!status" class="btn btn-info">
  <i class="fas fa-align-left"></i>
  <span>Toggle Sidebar</span>
</button> -->
<router-outlet></router-outlet>
</div>


</div>
